export default __webpack_public_path__ + "static/media/1.da378d3f.jpg";